// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DayOfWeek_wrap__KXVPf","label":"DayOfWeek_label__1XmBD"};